import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    container: 'h-2 bg-grey-70',
    progress: 'bg-brand-2'
  },
} satisfies VfConfig['progressBar']
